// Target groups (§11 `/groups`): fan-out targets. A group is N members (path + method) under one
// service; on claim the executor creates one run per member (groupMemberIndex distinguishes them).

import { Link } from "react-router-dom";
import { Api } from "../lib/api";
import { useAsync } from "../lib/useAsync";
import { Badge, Empty, ErrorBox, Spinner } from "../components/ui";

export function GroupsPage() {
  const { data, error, loading } = useAsync(() => Api.listGroups(), []);

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold text-white">Groups</h1>

      {loading && !data ? (
        <Spinner />
      ) : error ? (
        <ErrorBox error={error} />
      ) : !data || data.data.length === 0 ? (
        <Empty>No target groups yet.</Empty>
      ) : (
        <div className="space-y-3">
          {data.data.map((g) => (
            <div key={g.id} className="card">
              <div className="mb-2 flex items-center justify-between">
                <div className="font-mono text-sm font-semibold text-white">{g.id}</div>
                <Link className="mono text-xs text-primary hover:underline" to={`/services/${g.serviceId}`}>
                  {g.serviceId}
                </Link>
              </div>
              <div className="flex flex-wrap gap-2">
                {g.members.map((m, i) => (
                  <Badge key={i}>
                    {m.method} {m.path}
                  </Badge>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}